import { LOGOUT_URL } from "../constants";
import { eraseUserCookies } from "./cookies";

export const logoutUser = (returnUrl?: string) => {
  let url = `${LOGOUT_URL}`;
  if (returnUrl) {
    url = `${url}?returnTo=${returnUrl}`;
  }

  eraseUserCookies();
  window.location.href = url;
};
